import {REQUEST_PRICE_RATES, REQUEST_PRICE_RATES_FAILURE, REQUEST_PRICE_RATES_SUCCESS} from "../../../constant/PriceRateConstant";

const initialState = {
    price_rates: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const priceRatesReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_PRICE_RATES:
            return {
                ...state,
                price_rates: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_PRICE_RATES_SUCCESS:
            return {
                ...state,
                price_rates: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_PRICE_RATES_FAILURE:
            return {
                ...state,
                price_rates: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
